module.exports = __webpack_public_path__ + "img/code.6c697d18.svg";